export default __webpack_public_path__ + "i18n/translations/translation.3afa68a9.json";